"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M13.2003 5.903C13.2003 6.01 13.1563 6.113 13.0803 6.188L10.2333 8.971C10.0843 9.118 9.88327 9.2 9.67427 9.2H7.15527C6.87427 9.2 6.61327 9.052 6.47327 8.808C5.98827 7.961 5.00827 7.435 3.92027 7.646C2.97827 7.829 2.21327 8.605 2.04127 9.549C1.76327 11.073 2.92727 12.4 4.40027 12.4C5.28627 12.4 6.05327 11.917 6.46727 11.202C6.61027 10.955 6.87027 10.799 7.15627 10.799H9.67427C9.88327 10.799 10.0843 10.882 10.2333 11.028L13.0833 13.814C13.1583 13.887 13.2003 13.988 13.2003 14.092V17.2C13.2003 17.641 13.5583 18 14.0003 18H17.2003C17.6413 18 18.0003 17.641 18.0003 17.2V14C18.0003 13.558 17.6413 13.2 17.2003 13.2H15.0623C14.8503 13.2 14.6473 13.115 14.4973 12.965L12.0963 10.565C11.7843 10.253 11.7843 9.747 12.0963 9.434L14.4973 7.034C14.6473 6.884 14.8503 6.799 15.0623 6.799H17.2003C17.6413 6.799 18.0003 6.441 18.0003 6V2.799C18.0003 2.358 17.6413 2 17.2003 2H14.0003C13.5583 2 13.2003 2.358 13.2003 2.799V5.903Z",
    fill: "#727B7F"
  }));
};